import React, { useRef } from 'react';
import { Button, Icon } from 'antd';

/**
 * Native file-chooser that reads a JSON from disk (no backend) and hands the
 * parsed object up. It accepts a form template (carries `formSchema`/
 * `jsonSchema`) and routes it to `onTemplate`.
 */
export default function FileChooser({ onTemplate, onError }) {
  const inputRef = useRef(null);

  const handleFile = e => {
    const file = e.target.files && e.target.files[0];
    // Reset so choosing the same file again re-triggers onChange.
    e.target.value = '';
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      let json;
      try {
        json = JSON.parse(reader.result);
      } catch (err) {
        onError && onError(`Invalid JSON in "${file.name}": ${err.message}`);
        return;
      }
      if (!json || (!json.formSchema && !json.jsonSchema)) {
        onError &&
          onError(
            `"${file.name}" is not a form template (expected "formSchema" or "jsonSchema").`
          );
        return;
      }
      onTemplate(json, file.name);
    };
    reader.onerror = () => onError && onError(`Could not read "${file.name}".`);
    reader.readAsText(file);
  };

  return (
    <span>
      <Button
        type="primary"
        size="small"
        onClick={() => inputRef.current && inputRef.current.click()}
        data-testid="load-template-button"
      >
        <Icon type="upload" /> Load template…
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept="application/json,.json"
        style={{ display: 'none' }}
        onChange={handleFile}
        data-testid="template-file-input"
      />
    </span>
  );
}
